import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import VueHotjar from "vue-hotjar-next";
import Toast, { PluginOptions, POSITION } from "vue-toastification";

import "vue-toastification/dist/index.css";

import "@/core/plugins/prismjs";
import "bootstrap";
import "./gtm.js";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Actions } from "@/store/enums/StoreEnums";

// Global handler: any write blocked by the subscription guard / integration
// limit comes back as HTTP 403. Surface a single prompt that routes the user to
// the billing page, and refresh the subscription state so the banner updates.
let subscriptionPromptOpen = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const msg =
        error.response?.data?.message ||
        "Bu işlem için aktif aboneliğiniz bulunmuyor.";
      try {
        store.dispatch(Actions.GET_SUBSCRIPTION);
      } catch (e) {
        /* ignore */
      }
      if (!subscriptionPromptOpen) {
        subscriptionPromptOpen = true;
        Swal.fire({
          title: "Abonelik Gerekli",
          text: msg,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Abonelik Planı Seç",
          cancelButtonText: "Kapat",
        }).then((res) => {
          subscriptionPromptOpen = false;
          if (res.value) {
            router.push({ name: "billing" });
          }
        });
      }
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueHotjar, {
  id: 3298491,
  isProduction: true,
  snippetVersion: 6,
});
const toastOptions: PluginOptions = {
  position: POSITION.TOP_LEFT,
  timeout: 2000,
};
app.use(Toast, toastOptions);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
